export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // console.log(`${email} test: ${emailRegex.test(email)}`);
  return emailRegex.test(email);
};

export const isValidEmails = (email: string): boolean => {
  if (!email) return false;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  return email
    .split(';') // Split by semicolon
    .map(e => e.trim()) // Trim each email
    .filter(e => e.length > 0) // Remove empty entries
    .every(e => emailRegex.test(e)); // Validate all
};
